"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDefaultDatumIdKey = getDefaultDatumIdKey;
exports.getDefaultDatumIdValue = getDefaultDatumIdValue;
exports.getDefaultActivityFrom = getDefaultActivityFrom;
exports.hydratedActivityFrom = hydratedActivityFrom;
exports.merge = void 0;

var _pluralize = _interopRequireDefault(require("pluralize"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function getDefaultDatumIdKey() {
  return 'id';
}

function getDefaultDatumIdValue(datum, index) {
  if (typeof datum.id !== 'undefined') return datum.id;
  return index;
}

function getDefaultActivityFrom() {
  return {};
}

function hydratedActivityFrom(activity) {
  var stateKey = activity.stateKey;

  if (!stateKey) {
    if (activity.tableName) {
      stateKey = (0, _pluralize["default"])(activity.tableName, 2);
    } else if (activity.modelName) {
      stateKey = (0, _pluralize["default"])("".concat(activity.modelName[0].toLowerCase()).concat(activity.modelName.slice(1)), 2);
    } else {
      console.warn('Missing stateKey or tableName or modelName for that activity.');
    }
  }

  return _objectSpread(_objectSpread({}, activity), {}, {
    dateCreated: activity.dateCreated || new Date().toISOString(),
    stateKey: stateKey
  });
}

var merge = function merge(target, source) {
  var _loop = function _loop() {
    var key = _Object$keys[_i];

    if (source[key] instanceof Object) {
      if (Array.isArray(source[key])) {
        if (source[key][0]) {
          if (!(source[key][0] instanceof Object) || Array.isArray(source[key][0])) {
            target[key] = source[key];
            return "continue";
          }
        }

        target[key] = source[key].map(function (s, index) {
          return merge(_objectSpread({}, target[key] && target[key][index]), s);
        });
      } else {
        target[key] = merge(_objectSpread({}, target[key]), source[key]);
      }
    } else {
      target[key] = source[key];
    }
  };

  for (var _i = 0, _Object$keys = Object.keys(source); _i < _Object$keys.length; _i++) {
    var _ret = _loop();

    if (_ret === "continue") continue;
  }

  return target;
};

exports.merge = merge;